export default __webpack_public_path__ + "dc03080754ad15a406040c271b7b376b.svg";